import { Button } from "@/client/components/Controls"
import { useTranslation } from "react-i18next"
import { Panel, PanelGroup } from "rsuite"

export type MessageBoxButtonProps = { key: string, text: string }
export type MessageBoxProps = { message: string, buttons?: MessageBoxButtonProps[], onClick: (status: string) => void }

export function MessageBox({ message, buttons = [], onClick }: MessageBoxProps) {
    const { t } = useTranslation()

    if (buttons.length == 0) buttons.push({ key: 'ok', text: t('Ok') })

    return (
        <div className="overlay overlay-1060">
            <Panel className="messagebox">
                <PanelGroup className="messagebox-content">
                    {message}
                </PanelGroup>
                <PanelGroup className="messagebox-footer">
                    {buttons.map((item) => {
                        return (<Button key={item.key} onClick={() => onClick(item.key)}>{item.text}</Button>)
                    })}
                </PanelGroup>
            </Panel>
        </div>
    )
}
